import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ActionLink from "../controls/ActionLink";
import {Dropdown} from "react-bootstrap";
import FilterButton from "./FilterButton";
import FilterDropdown from "./FilterDropdown";

class NumberFilter extends Component {
    static propTypes = {
        fieldName: PropTypes.string.isRequired,
        filter: PropTypes.object,
        onChange: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        isOpen: false,
        isFilterOpened: true,
        isFacetOpened: false,
        value: this.props.filter ? (this.props.filter.value || '') : '',
        conditionId: this.props.filter ? (this.props.filter.condition || 'equal') : 'equal'
    };
    conditions = [
        {
            id: "equal",
            text: "Равно"
        },
        {
            id: "notEqual",
            text: "Не равно"
        },
        {
            id: "greaterThan",
            text: "Больше"
        },
        {
            id: "greaterThanOrEqual",
            text: "Больше или равно"
        },
        {
            id: "lessThan",
            text: "Меньше"
        },
        {
            id: "lessThanOrEqual",
            text: "Меньше или равно"
        }
    ];

    componentWillReceiveProps(nextProps) {
        let filter = nextProps.filter;

        if (nextProps.filter && this.state.value !== filter.value) {
            let value = filter.value || '';
            this.setState({value});
        }

        if (nextProps.filter && this.state.conditionId !== filter.condition) {
            let conditionId = filter.condition || 'equal';
            this.setState({conditionId});
        }
    }

    render() {
        const {fieldName} = this.props;
        return (
            <div className="input-group">
                <input type="number" className="form-control"
                       placeholder="Фильтр"
                       disabled={this.inputDisabled()}
                       value={this.state.value}
                       onChange={event => this.updateValue(event.target.value)}/>
                <div className="input-group-btn">
                    <Dropdown id={`${fieldName}-filter`} rootCloseEvent="click"
                              open={this.state.isOpen}
                              onToggle={isOpen => this.setState({isOpen})}>
                        <FilterButton bsRole="toggle"
                                      onClick={() => this.setState({isOpen: true})}/>
                        <FilterDropdown bsRole="menu">
                            <ul className="dropdown-menu p-a-1" style={{width: '300px', left: '-147px'}}>
                                <li>
                                    <ActionLink className="p-x-0"
                                                onClick={() => this.setState({isFilterOpened: !this.state.isFilterOpened})}>
                                        {
                                            this.state.isFilterOpened
                                                ? <i className="fa fa-chevron-down"/>
                                                : <i className="fa fa-chevron-right"/>
                                        }
                                        {' '}
                                        Фильтровать по условию...
                                    </ActionLink>
                                    {
                                        this.state.isFilterOpened &&
                                        <ul className="p-l-2">
                                            {this.conditions.map(condition =>
                                                <li key={condition.id}
                                                    className={this.state.conditionId === condition.id ? 'active' : ''}
                                                    style={{listStyleType: 'none'}}>
                                                    <ActionLink onClick={() => this.setState({conditionId: condition.id})}>
                                                        <i className="fa fa-check"
                                                           style={{visibility: this.state.conditionId === condition.id ? 'visible' : 'hidden'}}/>
                                                        {' '}
                                                        {condition.text}
                                                    </ActionLink>
                                                </li>
                                            )}
                                        </ul>
                                    }
                                </li>
                                <li className="pull-right m-t-1">
                                    <div className="btn-group" role="group">
                                        <button className="btn btn-default"
                                                disabled={!this.canApply()}
                                                onClick={() => this.apply()}>
                                            Применить
                                        </button>
                                        <button className="btn btn-default"
                                                disabled={!this.canReset()}
                                                onClick={() => this.reset()}>
                                            Очистить
                                        </button>
                                    </div>
                                </li>
                            </ul>
                        </FilterDropdown>
                    </Dropdown>
                </div>
            </div>
        );
    }

    inputDisabled() {
        const condition = this.conditions.find(c => c.id === this.state.conditionId);
        return condition.disableInput;
    }

    updateValue(value) {
        this.setState({value}, () => this.invokeOnChange());
    }

    canApply() {
        return this.state.value || this.condition.disableInput;
    }

    apply() {
        this.setState({
            value: this.condition.disableInput
                ? ''
                : this.state.value,
            isOpen: false
        }, () => this.invokeOnChange());
    }

    canReset() {
        return this.state.value || this.state.conditionId !== this.conditions[0].id;
    }

    reset() {
        const {onChange} = this.props;

        this.setState({
            isOpen: false,
            value: '',
            conditionId: this.conditions[0].id,
        }, () => this.invokeOnChange());
    }

    invokeOnChange() {
        const {onChange} = this.props;

        if (this.state.value || this.condition.disableInput) {
            onChange({
                fieldName: this.props.fieldName,
                type: 'numeric',
                condition: this.state.conditionId,
                value: this.state.value
            });
        }
        else {
            onChange(null);
        }
    }

    get condition() {
        return this.conditions.find(c => c.id === this.state.conditionId);
    }
}

export default NumberFilter;


// WEBPACK FOOTER //
// ./src/datagrid/NumberFilter.js